import { track, useEditor } from "tldraw"
import { StickerShape } from "../../shared/StickerShape"
import { LDPage } from "../../shared/LDPage"
import { Disc } from "lucide-react"
import { useCurrentPage } from "../hooks/useCurrentPage"

export const Origin = track(() => {
  const editor = useEditor()

  const currentPage = useCurrentPage()
  if (currentPage.meta.origin === undefined) return null
  const location = editor.pageToViewport(currentPage.meta.origin)

  if (
    editor.getSelectedShapeIds().length === 1 &&
    editor.getShape(editor.getSelectedShapeIds()[0])?.type === "sticker"
  ) {
    const shape = editor.getShape(
      editor.getSelectedShapeIds()[0],
    ) as StickerShape
    const originPage = editor.getPage(shape.props.pageId) as LDPage
    const shapeLocation = editor.pageToViewport(shape?.props.origin)
    if (
      shape &&
      shape.type === "sticker" &&
      shape.props.origin &&
      originPage.meta.originSet
    ) {
      return (
        <div
          style={{
            color: "blue",
            position: "absolute",
            top: shapeLocation.y - 10,
            left: shapeLocation.x - 10,
          }}
        >
          <Disc style={{ width: 20, height: 20 }} />
        </div>
      )
    }
  } else {
    if (!currentPage.meta.originSet) return null
    return (
      <div
        style={{
          color: "red",
          position: "absolute",
          top: location.y - 10,
          left: location.x - 10,
        }}
      >
        <Disc style={{ width: 20, height: 20 }} />
      </div>
    )
  }
})
